import { ChangeDetectorRef, Component } from "@angular/core";
import { Router } from "@angular/router";
import { AccountService, AppConfigService, AuthService } from "@app/core";
import { ViewAsPartnerService } from "@app/services";
import { TooltipManagerService, TooltipRegistrationService } from "@app/shared/services";
import { TranslocoService } from "@ngneat/transloco";
import { PlatformService, PosMarketplaceService } from "clearline-api";
import { UserPermissionService } from "clearline-common";
import { SidebarActionsService } from "../sidebar/services/sidebar-actions.service";
import { SidebarComponent } from "../sidebar/sidebar.component";

@Component({
  selector: "app-sidebar-horizontal",
  templateUrl: "./sidebar-horizontal.component.html",
  styleUrls: ["./sidebar-horizontal.component.scss"]
})
export class SidebarHorizontalComponent extends SidebarComponent {
  constructor(
    cdr: ChangeDetectorRef,
    router: Router,
    configSvc: AppConfigService,
    accountSvc: AccountService,
    authService: AuthService,
    userPermissionService: UserPermissionService,
    viewAsPartnerService: ViewAsPartnerService,
    sidebarActionsService: SidebarActionsService,
    platformService: PlatformService,
    posMarketplaceService: PosMarketplaceService,
    tooltipRegistration: TooltipRegistrationService,
    tooltipManager: TooltipManagerService,
    transloco: TranslocoService
  ) {
    super(
      cdr,
      router,
      configSvc,
      accountSvc,
      authService,
      userPermissionService,
      viewAsPartnerService,
      sidebarActionsService,
      platformService,
      posMarketplaceService,
      tooltipRegistration,
      tooltipManager,
      transloco
    );
  }
}
